(function () {
  const BADGE_SELECTORS = [
    '.jdgm-widget.jdgm-preview-badge',
    '.jdgm-prev-badge',
    '#judgeme_product_badge',
  ];

  // Try each selector in order; return the first match found on the page.
  const REVIEW_TARGET_SELECTORS = [
    '.jdgm-widget.jdgm-cards-carousel',
    '#judgeme_product_reviews',
    '.jdgm-widget.jdgm-all-reviews-widget',
    '.jdgm-all-reviews-widget',
    '.jdgm-all-reviews',
    '[id*="judgeme"]',
    '[id*="reviews"]',
    '[class*="jdgm-all-reviews"]',
  ];

  function findReviewsSection() {
    for (const sel of REVIEW_TARGET_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function applyJump(badge) {
    if (badge.dataset.jumpApplied) return;
    badge.dataset.jumpApplied = '1';
    badge.style.cursor = 'pointer';
    badge.addEventListener('click', function () {
      const target = findReviewsSection();
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  function findAndApply() {
    for (const sel of BADGE_SELECTORS) {
      document.querySelectorAll(sel).forEach(applyJump);
    }
  }

  findAndApply();

  const observer = new MutationObserver(findAndApply);
  observer.observe(document.body, { childList: true, subtree: true });
})();

